export class Translator {
	languageMap: Map<string, string> | null;

	constructor(languageMap: Map<string, string> | null) {
		this.languageMap = languageMap;
	}

	translate = (expression: string | null) => {
		if (!this.languageMap) return expression || '';
		if (!expression) return '';
		return this.languageMap.get(expression) || expression || '';
	};
}

export const supportedLanguages = ['pt', 'en', 'fr'];
